import React from "react";

const Process = () => {
  const steps = [
    {
      icon: "fa-search",
      title: "Requirement & Ad",
      desc: "We analyze employer needs and advertise job openings across top portals to attract the best talent.",
    },
    {
      icon: "fa-user-check",
      title: "Shortlisting",
      desc: "Our expert recruiters conduct robust screening and interviews to ensure candidates are job-ready.",
    },
    {
      icon: "fa-thumbs-up",
      title: "Selection",
      desc: "We present top-tier candidates to employers for final selection based on international standards.",
    },
    {
      icon: "fa-heartbeat",
      title: "Medical Check",
      desc: "Candidates undergo mandatory health tests at approved centers to meet Gulf health requirements.",
    },
    {
      icon: "fa-file-contract",
      title: "Verification",
      desc: "Thorough background checks and document attestation to ensure 100% authenticity.",
    },
    {
      icon: "fa-plane-departure",
      title: "Visa & Flight",
      desc: "Complete visa processing and travel arrangements for a smooth deployment journey.",
    },
  ];

  return (
    <div className="bg-light">
      <div className="container-xxl py-5 ">
        <div className="container">
          <div className="text-center pb-5 wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-light text-center text-primary px-3">
              Workflow
            </h6>
            <h1 className="mb-5">Our 6-Step Recruitment Journey</h1>
          </div>

          <div className="row g-4">
            {steps.map((step, index) => (
              <div
                className="col-lg-4 col-md-6 wow fadeInUp"
                key={index}
                data-wow-delay={`${0.1 * (index + 1)}s`}
              >
                <div
                  className="p-4 h-100 bg-white shadow-sm transition-all"
                  style={{
                    borderRadius: "30px 0 30px 0",
                    border: "1px solid rgba(134, 184, 23, 0.2)",
                    transition: "0.3s ease",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow =
                      "0 1rem 3rem rgba(134, 184, 23, 0.15)";
                    e.currentTarget.querySelector(".step-number").style.color =
                      "rgba(134, 184, 23, 0.2)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 .125rem .25rem rgba(0,0,0,.075)";
                    e.currentTarget.querySelector(".step-number").style.color =
                      "rgba(0,0,0,0.05)";
                  }}
                >
                  {/* Background Large Number */}
                  <span
                    className="step-number position-absolute fw-bold"
                    style={{
                      fontSize: "6rem",
                      top: "-10px",
                      right: "10px",
                      color: "rgba(0,0,0,0.05)",
                      transition: "0.3s ease",
                      zIndex: 0,
                    }}
                  >
                    {index + 1}
                  </span>

                  <div className="position-relative" style={{ zIndex: 1 }}>
                    <div
                      className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle mb-4 shadow"
                      style={{ width: "70px", height: "70px" }}
                    >
                      <i className={`fas ${step.icon} text-white fs-3`}></i>
                    </div>

                    <h4 className="mb-3 fw-bold">{step.title}</h4>

                    <div
                      className="bg-primary mb-3"
                      style={{
                        width: "40px",
                        height: "4px",
                        borderRadius: "2px",
                      }}
                    ></div>

                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
                    >
                      {step.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Process;
